// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Qi-z","heading":"Ri-z","brandPromo":"Si-z"};